// @flow
import FixedLayer from './FixedLayer';

export default FixedLayer;
